import { useState } from 'react';
import { usePermissions } from '../../../../../hooks/usePermissions';
import { ProviderContractDatabase } from '../../../../../types';
import { getContractEndDate } from '../../../utils/getContractEndDate';
import { getContractStatus, getRenewalLabel } from '../../../utils/getContractStatus';

type Props = {
  contract: ProviderContractDatabase;
};

export function useContractCard(props: Props) {
  const { isAdmin } = usePermissions();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const endDate = getContractEndDate(props.contract);

  return {
    isAdmin,
    endDate,
    status: getContractStatus(endDate),
    renewalLabel: endDate ? getRenewalLabel(props.contract.duration_of_renewal) : null,
    isEditModalOpen,
    isDeleteModalOpen,
    handleOpenEditModal: () => setIsEditModalOpen(true),
    handleCloseEditModal: () => setIsEditModalOpen(false),
    handleOpenDeleteModal: () => setIsDeleteModalOpen(true),
    handleCloseDeleteModal: () => setIsDeleteModalOpen(false),
  };
}
